<template>
	<Layout>
		<div class="team-fans-page">
			<div class="page-content" v-loading.fullscreen.lock="pageLoading" element-loading-text="加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.45)">
				
				<!-- 页面头部 -->
				<div class="page-header">
					<h2>团队成员</h2>
					<p>查看团队成员详细列表</p>
				</div>

				<!-- 成员列表 -->
				<div class="list-content">
					<TeamFansList />
				</div>

			</div>
		</div>
	</Layout>
</template>

<script>
import Layout from '@/components/Layout/index'
import TeamFansList from './components/TeamFansList'

export default {
	name: 'TeamFans',
	components: {
		Layout,
		TeamFansList
	},
	data() {
		return {
			pageLoading: false
		}
	}
}
</script>

<style lang="scss" scoped>
.team-fans-page {
	min-height: 100vh;
	background-color: #f5f7fa;
	padding: 20px;
}

.page-content {
	min-height: calc(100vh - 80px);
}

.page-header {
	margin-bottom: 20px;
	
	h2 {
		color: #303133;
		font-size: 24px;
		font-weight: 600;
		margin: 0 0 8px 0;
	}
	
	p {
		color: #909399;
		font-size: 14px;
		margin: 0;
	}
}

.list-content {
	// background: #fff;
	// border-radius: 8px;
	min-height: 500px;
}
</style>
